import { cn } from '@/lib/utils';

export const StatusDot = ({ className, count, ...props }) => {
  return (
    <div data-testid="status-dot" className={cn('rounded-full h-2 w-2 p-0 relative', className)} {...props}>
      <span className="absolute top-0 right-0 left-0 text-onColor text-[6px]">{count}</span>
    </div>
  );
};
